// extracted by mini-css-extract-plugin
module.exports = {"iconFooter__icons":"iconFooter_iconFooter__icons__3W8BK","semiBold":"iconFooter_semiBold__3H44I","callToBook":"iconFooter_callToBook__2GjsK"};